import React from 'react';
import { Tabs as Component } from '@vfuk/core-tabs';
const Tabs = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Tabs;
